import { render, staticRenderFns } from "./AppErrReminder.vue?vue&type=template&id=409aa3e0&scoped=true&"
import script from "./AppErrReminder.vue?vue&type=script&lang=js&"
export * from "./AppErrReminder.vue?vue&type=script&lang=js&"
import style0 from "./AppErrReminder.vue?vue&type=style&index=0&id=409aa3e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409aa3e0",
  null
  
)

export default component.exports